<!-- @format -->

<sis-expandable [title]="title" [level]="3" size="xs" variant="link">
  <ng-template sisExpandableContent>
    <textarea [value]="message" class="form-control sis-mb-xxs" rows="10" readonly></textarea>
    <sis-button (clicked)="copyToClipboard()" size="sm" [hollow]="true">{{ "COMMON.COPY_ERROR" | transloco }}</sis-button>
  </ng-template>
</sis-expandable>
